import { useEffect, useState } from 'react'

import { getDocumentObject } from '../utils/commonUtils'

export const MOBILE_BREAKPOINT = 968

const isNarrowerThan = (breakpoint: number) => (getDocumentObject() ? window.innerWidth < breakpoint : false)

/**
 * Web-only. `true` while the viewport is narrower than `breakpoint`.
 *
 * The initial value is read synchronously during the first render on purpose — this is deliberately
 * not built on top of `useWindowSize`, whose `[0, 0]` seed would report mobile for one painted frame
 * on desktop and remount anything branching on it.
 *
 * There is no `window.innerWidth` on React Native, so this is always `false` there.
 */
export const useIsMobile = (breakpoint: number = MOBILE_BREAKPOINT) => {
  const [isMobile, setIsMobile] = useState<boolean>(() => isNarrowerThan(breakpoint))

  useEffect(() => {
    // this hook lives in a cross platform package, but only the web has a resizable window
    if (!getDocumentObject()) {
      return
    }
    const checkForMobile = () => setIsMobile(isNarrowerThan(breakpoint))
    checkForMobile()
    window.addEventListener('resize', checkForMobile)
    return () => window.removeEventListener('resize', checkForMobile)
  }, [breakpoint])

  return isMobile
}
